import React, { useEffect, useState } from 'react';
import { ArrowRight, MapPin, Download, Linkedin, Briefcase } from 'lucide-react';
import { trackEvent } from '../lib/analytics';

const DYNAMIC_TEXTS = [
  'ML Systems',
  'GenAI Products',
  'Analytics Platforms',
  'Decision Intelligence',
  'Data & AI Strategy',
];

const Hero = ({ data }) => {
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    const interval = setInterval(() => {
      setTextIndex((prev) => (prev + 1) % DYNAMIC_TEXTS.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const scrollToContact = () => {
    trackEvent('get_in_touch_click');
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            {data.headshot && (
              <div
                className="v2-headshot"
                role="img"
                aria-label={`${data.name} headshot`}
                style={{ backgroundImage: `url('${data.headshot}')` }}
              >
                <span className="v2-headshot-fallback" aria-hidden="true">
                  {data.name.split(' ').map((w) => w[0]).slice(0, 2).join('')}
                </span>
              </div>
            )}

            <div className="hero-label">
              <MapPin size={16} />
              <span>{data.location}</span>
            </div>

            <h1 className="hero-title">
              {data.name}
            </h1>

            <div className="hero-subtitle">
              <span className="static-text">{data.title}</span>
            </div>

            <div className="hero-dynamic">
              <span className="dynamic-label">Specializing in </span>
              <span className="dynamic-text" key={textIndex}>
                {DYNAMIC_TEXTS[textIndex]}
              </span>
            </div>

            <p className="hero-description">
              Building practical{' '}
              <span className="hero-highlight">Data &amp; AI systems</span>{' '}
              that turn complex operational data into{' '}
              <span className="hero-highlight">decisions</span>.
            </p>

            <div className="hero-actions">
              <button className="btn-primary" onClick={scrollToContact}>
                <span>Get In Touch</span>
                <ArrowRight size={20} />
              </button>
              {data.resume && (
                <a
                  href={data.resume}
                  download
                  className="btn-secondary"
                  aria-label="Download CV as PDF"
                  onClick={() => trackEvent('download_cv_click')}
                >
                  <span>Download CV</span>
                  <Download size={18} />
                </a>
              )}
              {data.consultingUrl && (
                <a
                  href={data.consultingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-secondary"
                  onClick={() => trackEvent('consulting_click')}
                >
                  <span>Consulting</span>
                  <Briefcase size={18} />
                </a>
              )}
              <a
                href={data.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary"
                onClick={() => trackEvent('linkedin_click')}
              >
                <span>View LinkedIn</span>
                <Linkedin size={18} />
              </a>
            </div>

            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-headline">
                  <span className="stat-num">8+</span>
                  <span className="stat-word">Years</span>
                </div>
                <div className="stat-label">Data, AI &amp; Analytics Experience</div>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <div className="stat-headline">
                  <span className="stat-num">30+</span>
                  <span className="stat-word">Solutions</span>
                </div>
                <div className="stat-label">Built Across AI, Data &amp; Analytics</div>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <div className="stat-headline">
                  <span className="stat-num">7+</span>
                  <span className="stat-word">Certs</span>
                </div>
                <div className="stat-label">AI, Cloud &amp; Data Platforms</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
